import { ProductPricingInput } from "../types/pricing/price-display.types";

type ProductPricingSubset = Pick<
  ProductPricingInput,
  | "mpvId"
  | "productId"
  | "version"
  | "alternateSelections"
  | "selections"
  | "displayVariant"
  | "requestedPriceDisplayStrategy"
  | "docRefUrl"
  | "assumeDocRequiresCertification"
>;

type SerializableValue =
  | string
  | number
  | boolean
  | Record<string, string>
  | Array<number>;

export const getPriceQueryId = (priceQuery: ProductPricingSubset): string => {
  if (typeof priceQuery !== "object" || priceQuery === null) {
    throw new Error("Input must be a non-null object");
  }

  const serialize = (
    value: SerializableValue,
  ): string => {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value);
    } else if (Array.isArray(value)) {
      return value.map((item) => String(item)).join("-");
    } else if (typeof value === "object" && value !== null) {
      return Object.keys(value)
        .sort()
        .map(key => `${key}:${serialize(value[key])}`)
        .join("::");
    } else {
      return String(value);
    }
  };

  const parts: string[] = [];
  const queryKeys = Object.keys(priceQuery).sort();

  queryKeys.forEach((key) => {
    const value = priceQuery[key as keyof typeof priceQuery];
    if (
      value === undefined ||
      (typeof value === "object" && value !== null && Object.keys(value).length === 0)
    ) {
      return;
    }
    parts.push(`${key}:${serialize(value)}`);
  });

  return parts.sort().join("::");
};
